var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotMobileIlustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 205,
    viewBox: "0 0 129 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    x: 30.6022,
    y: 61.2042,
    width: 8.16058,
    height: 13.2609,
    rx: 4.08029,
    fill: "url(#paint0_linear_25_2120)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    x: 99.457,
    y: 61.2042,
    width: 8.16058,
    height: 13.2609,
    rx: 4.08029,
    fill: "url(#paint1_linear_25_2120)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3",
    filter: "url(#filter0_d_25_2120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6782 40.0378C62.8375 25.9321 76.4036 26.2624 100.562 40.0378C124.72 53.8131 14.5189 54.1434 38.6782 40.0378Z",
    fill: "url(#paint2_linear_25_2120)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 19",
    filter: "url(#filter1_d_25_2120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.6824,
    y: 52.0237,
    width: 68.8549,
    height: 30.0921,
    rx: 15.0461,
    fill: "#3B457B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 20",
    filter: "url(#filter2_i_25_2120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.8632,
    y: 61.2042,
    width: 51.0036,
    height: 11.2208,
    rx: 5.6104,
    fill: "#F0F1F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    filter: "url(#filter3_d_25_2120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0839 64.7745C53.3938 64.7745 52.0237 66.6013 52.0237 68.8548H58.1441C58.1441 66.6013 56.774 64.7745 55.0839 64.7745Z",
    fill: "#5F6CB4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3",
    filter: "url(#filter4_d_25_2120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1359 64.7745C81.4458 64.7745 80.0757 66.6013 80.0757 68.8548H86.1961C86.1961 66.6013 84.826 64.7745 83.1359 64.7745Z",
    fill: "#5F6CB4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 21",
    filter: "url(#filter5_i_25_2120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.3447,
    y: 74.4652,
    width: 3.57025,
    height: 5.10036,
    rx: 1.78513,
    fill: "#F0F1F9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    x: 59.6742,
    y: 87.2162,
    width: 18.8713,
    height: 7.1405,
    fill: "#191E3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M87.7008 86.4511C73.3841 90.9237 65.345 90.8189 51.0289 86.4511C36.7129 82.0833 102.017 81.9786 87.7008 86.4511Z",
    fill: "url(#paint3_linear_25_2120)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 16.7755,
    y: 126.557,
    width: 28.0991,
    height: 4.19389,
    rx: 2.09694,
    transform: "rotate(-33.433 16.7755 126.557)",
    fill: "#191E3A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    x: 18.9169,
    y: 129.905,
    width: 12.4608,
    height: 4.19389,
    rx: 2.09694,
    transform: "rotate(-118.344 18.9169 129.905)",
    fill: "#191E3A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 27",
    y: 101.735,
    width: 11.7429,
    height: 27.2603,
    rx: 5.87144,
    transform: "rotate(-27.037 0 101.735)",
    fill: "url(#paint4_linear_25_2120)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 28",
    x: 97.1746,
    y: 113.037,
    width: 28.099,
    height: 4.19389,
    rx: 2.09694,
    transform: "rotate(24.3239 97.1746 113.037)",
    fill: "#191E3A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 29",
    x: 114.205,
    y: 134.711,
    width: 12.4608,
    height: 4.19389,
    rx: 2.09694,
    transform: "rotate(-69.6014 114.205 134.711)",
    fill: "#191E3A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    x: 112.484,
    y: 128.311,
    width: 11.7429,
    height: 27.2603,
    rx: 5.87144,
    transform: "rotate(20.3986 112.484 128.311)",
    fill: "url(#paint5_linear_25_2120)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 5",
    filter: "url(#filter6_d_25_2120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.1098,
    cy: 192.539,
    r: 4.33531,
    fill: "url(#paint6_linear_25_2120)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 5",
    filter: "url(#filter7_d_25_2120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8501 119.831H67.8145V158.669H91.2932C99.5437 142.871 99.412 121.367 98.3149 112.59C96.2084 97.8443 83.979 94.3042 78.1276 94.3773H61.6705C41.6588 93.6752 38.1187 111.054 38.8501 119.831Z",
    fill: "url(#paint7_linear_25_2120)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 6",
    filter: "url(#filter8_d_25_2120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9369 120.928H38.8502C38.8502 161.127 61.2318 180.173 69.57 184.123C79.7514 178.506 87.8556 165.691 90.635 159.986H66.9369V120.928Z",
    fill: "url(#paint8_linear_25_2120)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6",
    filter: "url(#filter9_i_25_2120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.4311,
    cy: 119.603,
    r: 4.33531,
    fill: "#F0F1F9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 20",
    filter: "url(#filter10_d_25_2120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 7",
    d: "M60.2118 11.1591C59.9665 8.49084 60.9406 5.81723 62.5947 3.80773C64.251 1.79551 66.5444 0.5 68.8946 0.5C71.244 0.5 73.5201 1.7933 75.1681 3.80465C76.814 5.81351 77.7901 8.48967 77.5768 11.1651C77.4545 12.6985 76.5461 13.8383 75.552 15.0042C75.512 15.0512 75.4717 15.0983 75.4314 15.1455C74.9848 15.6681 74.5237 16.2076 74.1705 16.7702C73.8645 17.2574 73.6234 17.7857 73.5332 18.3713H64.7235C64.583 17.8274 64.29 17.3295 63.947 16.8685C63.5936 16.3934 63.1544 15.9164 62.7194 15.444C62.6197 15.3356 62.5201 15.2276 62.4219 15.1198C61.3355 13.9277 60.3546 12.7123 60.2118 11.1591Z",
    stroke: "#3B457B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 8",
    d: "M69.1493 24.4817C71.8253 24.4817 73.9946 21.9699 73.9946 18.8713H64.304C64.304 21.9699 66.4733 24.4817 69.1493 24.4817Z",
    fill: "#3B457B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M69.1493 8.92566V18.6163",
    stroke: "#3B457B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 69.1494,
    cy: 7.3956,
    r: 1.28513,
    stroke: "#3B457B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M64.5591 20.4014H73.7397",
    stroke: "#3B457B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_2120",
    x: 31.1925,
    y: 29.582,
    width: 76.8549,
    height: 28.9115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_25_2120",
    x: 30.6824,
    y: 52.0237,
    width: 76.8549,
    height: 38.0922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_25_2120",
    x: 43.8632,
    y: 61.2042,
    width: 51.0037,
    height: 15.2208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_25_2120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_25_2120",
    x: 48.0237,
    y: 64.7745,
    width: 14.1205,
    height: 12.0803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_25_2120",
    x: 76.0757,
    y: 64.7745,
    width: 14.1205,
    height: 12.0803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_25_2120",
    x: 68.3447,
    y: 74.4652,
    width: 3.57031,
    height: 9.10034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_25_2120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_25_2120",
    x: 60.7745,
    y: 188.203,
    width: 16.6707,
    height: 16.6707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_25_2120",
    x: 34.7627,
    y: 94.3567,
    width: 68.084,
    height: 72.3127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.152941 0 0 0 0 0.286275 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_25_2120",
    x: 34.8502,
    y: 120.928,
    width: 59.7848,
    height: 71.1951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.188235 0 0 0 0 0.345098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_25_2120",
    x: 81.0958,
    y: 115.268,
    width: 8.67065,
    height: 12.6707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_25_2120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_25_2120",
    x: 55.6742,
    y: 0,
    width: 26.4316,
    height: 32.4817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_2120",
    x1: 34.6825,
    y1: 61.2042,
    x2: 34.6825,
    y2: 74.4652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#5F6CB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_2120",
    x1: 103.537,
    y1: 61.2042,
    x2: 103.537,
    y2: 74.4652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#5F6CB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_2120",
    x1: 69.6199,
    y1: 29.582,
    x2: 69.6199,
    y2: 50.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#6E7BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B457B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_2120",
    x1: 69.3649,
    y1: 89.7664,
    x2: 69.3649,
    y2: 83.1359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#313756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25_2120",
    x1: 5.87144,
    y1: 101.735,
    x2: 5.87144,
    y2: 128.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#5F6CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B457B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25_2120",
    x1: 118.356,
    y1: 128.311,
    x2: 118.356,
    y2: 155.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#5F6CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4ABD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25_2120",
    x1: 69.1098,
    y1: 188.203,
    x2: 69.1098,
    y2: 196.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D6AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B457B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25_2120",
    x1: 68.8047,
    y1: 94.3567,
    x2: 68.8047,
    y2: 158.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F6CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3B457B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25_2120",
    x1: 64.7426,
    y1: 120.928,
    x2: 64.7426,
    y2: 184.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191E3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotMobileIlustration);
export default __webpack_public_path__ + "static/media/robot_mobile_ilustration.c84e1a3c93b6ae5873f27ed3c89247ec.svg";
export { ForwardRef as ReactComponent };